import React, { useState, useRef } from 'react';
import { SearchForm } from '@truelime/react-search';
import axios from 'axios';
import OverviewBlock from '@truelime/react-overview';
import { Templates } from '../../index';
import SearchItem from '../OverviewItem/SearchItem';
const axiosInstance = axios.create({
    baseURL: '/'
});
const Search = (formConfig) => {
    const formRef = useRef();
    const [results, setResults] = useState([]);
    const getSearchParam = () => {
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        return searchParams.get('searchtext');
    };
    const searchIsActive = () => {
        return getSearchParam()?.trim().length > 0;
    };
    return (<div className="search">
      <div className="form">
        <h1 className="form__title">Zoeken op de site</h1>
          <SearchForm formRef={formRef} templates={Templates} config={formConfig} axios={axiosInstance} filterBackend={false} onResults={(results) => {
        setResults(results);
    }}/>
      </div>

      {searchIsActive() &&
        <div className="overview__container">
          <div className="overview__block">
            <div className="overview__content">
              <OverviewBlock loadMoreItemsError="Er is een fout opgetreden" page={1} items={results} noItemsText="Geen resultaten..." paging="toggle" renderItem={(itemProps) => {
            return <SearchItem {...itemProps}/>;
        }}/>

              <a href={`/zoeken?searchtext=${getSearchParam()}`}>Toon alle resultaten</a>
            </div>
          </div>
        </div>}
    </div>);
};
export default Search;
